import { IRootState } from "../interfaces";

export const getProjects = (state: IRootState) => state.projectReducer.projects;

export const getProject = (state: IRootState) => state.projectReducer.project;
